import React, { useState, useEffect, useMemo } from "react";

import { useDispatch, useSelector } from "react-redux";
import moment from "moment";

import { useFetchCustomerTaskPodTableDataQuery } from "../../utils/customer/customerTaskTable";

import useDropdownPosition from "../../hooks/Dropdown/useDropDownPosition";
import Tooltip from "@mui/material/Tooltip";
import Button from "@mui/material/Button";
import { ReactComponent as PlusInsideSquare } from "../../assets/images/plusInsideSquare.svg";
import { ReactComponent as CloseModal2 } from "../../assets/images/closeModal2.svg";
import { ReactComponent as CloseModal1 } from "../../assets/images/closeModal2.svg";

import { ReactComponent as ContactIcon } from "../../assets/images/icons/ContactIcon.svg";
import { ReactComponent as TaskMenu } from "../../assets/images/icons/TaskMenu.svg";
import { ReactComponent as Groupicon } from "../../assets/images/icons/GroupIcon.svg";
import { ReactComponent as AppointmentIcon } from "../../assets/images/icons/AppointmentIcon.svg";
import { ReactComponent as MeetingIcon } from "../../assets/images/icons/MeetingIcon.svg";
import { ReactComponent as AddTaskProject } from "../../assets/images/icons/AddTaskProject.svg";
import { ReactComponent as DefaultTask } from "../../assets/images/icons/DefaultTask.svg";
import { ReactComponent as Task } from "../../assets/images/icons/Task.svg";
import { ReactComponent as TaskIcon } from "../../assets/images/icons/TaskIcon.svg";
import { ReactComponent as linkIcon } from "../../assets/images/linkIcon.svg";
import { ReactComponent as AddIcon } from "../../assets/images/icons/addIcon.svg";
import { ReactComponent as SearchIconDark } from "../../assets/images/icons/searchIconDark.svg";
import CategoryRibbon from "../../assets/images/icons/CategoryRibbon ";
import { getFormatDate } from "../../utils/utilityFunctions/dateUtility";
import { useLocation } from "react-router-dom";
import { Search } from "@mui/icons-material";
import CustomDrawer from "../UniversalComponents/CustomDrawer";
import { getCompanyId, getOrganizationId, getUserId, getUserToken } from "../../utils/utilityFunctions/localServices";
import { pushAlert } from "../../utils/alertSlice";
import { getColorForName, getSentenceCase, safeJsonParse } from "../../utils/utilityFunctions/stringUtility";
import { motion } from "framer-motion";
import { ReactComponent as NoTaskIcon } from "../../assets/images/NoTaskIcon.svg";
import AddButton from "../UniversalComponents/AddButton";
import MotionSearchBox from "../UniversalComponents/MotionSearchBox";
import { hideLoader, showLoader } from "../../utils/loaderSlice";
import CircularLoader from "../UniversalComponents/CircularLoader";
import EditOptionsModal from "../Task/TaskRecurrence/EditOptionsModal";
import { ReactComponent as LeadIcon } from "../../assets/images/LeadIcon.svg";
import UniversalCardComponent from "../UniversalComponents/UniversalCardComponent.js";
import TaskRadioButton from "../UniversalComponents/CompletionCheckbox";
import { ReactComponent as NewLeadIcon } from "../../assets/images/icons/NewLeadIcon.svg";
import { ReactComponent as NewTaskIcon } from "../../assets/images/icons/NewTaskIcon.svg";
import { ReactComponent as NewOtherIcon } from "../../assets/images/icons/NewOtherIcon.svg";
import { ReactComponent as NewDealIcon } from "../../assets/images/icons/NewDealIcon.svg";
import { ReactComponent as NewAddIcon } from "../../assets/images/addTaskModPlusIcn.svg";
import { hexToRgba } from "../../utils/utilityFunctions/color";
import { useLazyFetchAllTasksQuery } from "../../utils/customer/customerSelect";

const formatDate = (date) => {
  if (!date) return "";
  const d = new Date(date);
  const formattedDate = `${d.getDate().toString().padStart(2, "0")}-${(d.getMonth() + 1).toString().padStart(2, "0")}-${d.getFullYear()}`;
  return formattedDate;
};
function formatDate1(dateString) {
  const date = new Date(dateString);

  const day = date.getDate();
  const month = date.toLocaleString("en-US", { month: "short" });

  return `${day}${month}`;
}

function formatValue(item) {
  if (item) {
    const words = item.split(" ");
    const firstWord = words[0];
    const lastWord = words[words.length - 1];
    const firstChar = firstWord.charAt(0).toUpperCase();
    const lastChar = lastWord.charAt(0).toUpperCase();
    return `${firstChar}${lastChar}`;
  }
  return null;
}
const TasListkModal = ({
  isOpen,
  openSecondPopup,

  closePopup,
  customerId,

  secondPopupOpen,
  isTaskPodSuccess,
  leadTypeValue,
  moduleId,
  rowId,
}) => {
  console.log("moduleId in tasklist modal:", moduleId, rowId);
  // const { token } = useRequireAuth();
  const dispatch = useDispatch();
  const location = useLocation();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [customerTablePagination, setCustomerTablePagination] = useState("");
  const [customer, setCustomer] = useState([]);
  const hashValue = location.hash;
  const [editcustomerId, setEditCustomerId] = useState("");
  const [isActive, setIsActive] = useState(false);
  const [activtyId, setActivityId] = useState("");
  const { dropdownPosition, dropdownRef } = useDropdownPosition(true, "tasklistpop");
  const [dropdownCoord, setDropdownCoord] = useState(null);
  const [openTooltip, setOpenTooltip] = useState(false);
  const [quiFilter, setQuiFilter] = useState();
  const [userDataId, setUserDataId] = useState([]);
  const [activeTab, setActiveTab] = useState(Boolean(hashValue.replace("#", "")) ? hashValue : "#all");
  const [newPayload, setNewPayload] = useState([]);
  const [taskpodPayload, setTaskpodPayload] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 540);
  const [isAddButtonActive, setIsAddButtonActive] = useState(false);
  let token = JSON.parse(localStorage.getItem("myUserData"));

  const [isExpanded, setIsExpanded] = useState(true);
  const [searchText, setSearchText] = useState("");
  const [loading, setLoading] = useState(false);
  const [editData, setEditData] = useState();
  const storedData = localStorage.getItem("company_data");
  const companyId = storedData ? JSON.parse(storedData) : null;
  // const [selected, setSelected] = useState("task");
  const [taskId, setTaskId] = useState(null);

  const imageICons = {
    task: <NewTaskIcon />,
    lead: <NewLeadIcon />,
    deal: <NewDealIcon />,
    Other: <NewOtherIcon />,
  };
  const taskList = safeJsonParse(localStorage.getItem("taskList"));

  useEffect(() => {
    if (dropdownCoord !== null && !isActive) {
      setIsActive(true);
    }
  }, [dropdownCoord]);

  const getCreatePortalPositionEvent = (event) => {
    return {
      top: event.clientY - 30, // Y-coordinate of the click plus 50
      left: event.clientX + 15, // X-coordinate of the click plus 100
    };
  };

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 640);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const openPopup = () => {
    setIsPopupOpen(true);
  };

  // const {
  //   data: customerTableALL,
  //   isLoading,
  //   // refetch: refetchCustomerData,
  // } = useFetchCustomerTaskPodTableDataQuery({
  //   company_id: companyId,
  //   customer_id: customerId,
  //   user_id: getUserId(),
  //   org_id: getOrganizationId(),
  //   token: token,
  //   category_filter: leadTypeValue,
  //   visibility_status: "active",

  //   // pagination: `${customerTablePagination}&per_page=1000`,
  //   // paginate: true,
  //   // quiFilter: quiFilter?.value,
  //   // token: token,
  //   // assign_id: userDataId?.id,
  //   // filter_tab: activeTab.slice(1),
  //   // group_by_fields: newPayload,
  //   // task_pod: taskpodPayload?.value,
  //   // get_project: leadTypeValue === "project",
  // });

  const [
    GetAllTasks,
    {
      data: fetchGetAllTasks,
      isLoading: isfetchGetAllTasksLoading,
      isError: isfetchGetAllTasksError,
      isSuccess: isfetchGetAllTasksSuccess,
      error: fetchGetAllTasksError,
    },
  ] = useLazyFetchAllTasksQuery();

  useEffect(() => {
    if (isfetchGetAllTasksLoading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }

    if (isfetchGetAllTasksSuccess && fetchGetAllTasks?.status) {
      dispatch(
        pushAlert({
          message: fetchGetAllTasks?.message || "Tasks fetched successfully",
          type: "success",
          visible: true,
        })
      );
    }

    if (isfetchGetAllTasksError) {
      dispatch(
        pushAlert({
          message: fetchGetAllTasksError?.data?.message || "Failed to fetch tasks",
          type: "danger",
          visible: true,
        })
      );
    }
  }, [
    isfetchGetAllTasksLoading,
    isfetchGetAllTasksSuccess,
    isfetchGetAllTasksError,
    fetchGetAllTasks?.data,
    fetchGetAllTasksError, // ✅ include this if you access it inside
  ]);
  console.log(taskId, "taskId");

  const refetchCustomerData = async () => {
    await GetAllTasks({
      taskTemplateId: taskId, // task fixed id for task
      isPagination: true,
      customer_id: customerId,
      ...(moduleId ? { moduleId } : {}),
      ...(rowId ? { rowId } : {}),
    });
  };

  useEffect(() => {
    if (taskList && Array.isArray(taskList)) {
      const matchedItem = taskList?.find((item) => item.label === leadTypeValue);
      if (matchedItem) {
        setTaskId(matchedItem.id);
      }
    } else {
      console.error("taskList is not an array or is invalid:", taskList);
    }
  }, [leadTypeValue, taskList]);

  useEffect(() => {
    if (taskId || isTaskPodSuccess) {
      refetchCustomerData();
    }
  }, [taskId, isTaskPodSuccess]); // ✅ depends on taskId, not leadTypeValue

  useEffect(() => {
    if (isfetchGetAllTasksLoading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }

    if (isfetchGetAllTasksSuccess && fetchGetAllTasks?.status) {
      dispatch(
        pushAlert({
          message: fetchGetAllTasks?.message || "Tasks fetched successfully",
          type: "success",
          visible: true,
        })
      );
      const { data, ...restData } = fetchGetAllTasks;
      setCustomer(data);
    }

    if (isfetchGetAllTasksError) {
      dispatch(
        pushAlert({
          message: fetchGetAllTasksError?.data?.message || "Failed to fetch tasks",
          type: "danger",
          visible: true,
        })
      );
    }
  }, [
    fetchGetAllTasks,
    isfetchGetAllTasksLoading,
    isfetchGetAllTasksSuccess,
    isfetchGetAllTasksError,
    fetchGetAllTasks?.data,
    fetchGetAllTasksError,
  ]);

  const escapeRegExp = (string) => {
    return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  };
  function toPascalCase(str) {
    return str
      ?.toLowerCase()
      ?.split(" ")
      ?.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  }

  const highlightText = (text, query) => {
    if (!text || !query) return text || "";

    const textStr = String(text);
    const words = query.trim().split(/\s+/).filter(Boolean); // Split into non-empty words

    try {
      const regex = new RegExp(`(${words.map(escapeRegExp).join("|")})`, "gi");
      const parts = textStr.split(regex);
      return parts.map((part, index) =>
        regex.test(part) ? (
          <span key={index} className="bg-yellow-200">
            {part}
          </span>
        ) : (
          part
        )
      );
    } catch (error) {
      return textStr;
    }
  };

  const handleEditFields = (selection) => {
    const Selectedaccordfield = { ...editData, selection };
    setEditData(Selectedaccordfield);
    if (selection === "entire") {
      openSecondPopup({ ...editData, selection, recurModal: true });
    }
  };

  const filtered = customer?.filter(
    (item) =>
      item.subject?.toLowerCase().includes(searchText.toLowerCase()) ||
      item.status?.toLowerCase().includes(searchText.toLowerCase()) ||
      item.category_id?.toLowerCase().includes(searchText.toLowerCase()) ||
      item.priority?.toLowerCase().includes(searchText.toLowerCase())
  );

  const TaskCompletionCheckbox = ({ isChecked }) => {
    return (
      <div
        className="flex items-center text-black cursor-pointer"
        // onClick={(e) => handleClickCompleted()}
      >
        <TaskRadioButton isChecked={isChecked} size="small" />
      </div>
    );
  };

  return (
    <>
      <CustomDrawer variant="temporary" anchor="right" disableBackdropClick={true} open={isOpen} onClose={closePopup}>
        <div
          className="flex flex-col min-h-screen  overflow-hidden "
          // ref={closeTaskModalOutside}
        >
          <div className=" flex items-center justify-between w-full overflow-hidden px-4 py-3  rounded-t bg-white min-h-10">
            <div className="flex flex-col  grow min-w-0 ">
              <h3 className="text-base font-medium text-2C495D truncate text-nowrap">
                {getSentenceCase(fetchGetAllTasks?.data[0]?.customer_name)}
              </h3>
              {/* <div className="flex items-center gap-1 mt-1">
                <LeadIcon />
                <h4
                  className="text-sm text-gray-600 mt-1 font-poppins text-[12px] font-500 "
                  style={{ color: "rgba(29, 68, 105, 0.5)" }}
                >
                  Lead
                </h4>
              </div> */}

              {/* deal/task/lead text */}

              {/* {filtered[0] && (
                <div className="flex items-center gap-x-1 text-[#868686]">
                  {imageICons[filtered[0]?.category_id]}
                  <span className="text-xs px-1 z-10 font-poppins">
                    {highlightText(toPascalCase(filtered[0]?.category_id), searchText)}
                  </span>
                </div>
              )} */}
            </div>

            <button
              onClick={closePopup}
              type="button"
              className="text-454545 bg-transparent hover:bg-F1F5F8 rounded-lg text-sm  ms-auto inline-flex justify-center items-center"
              data-modal-hide=""
            >
              <CloseModal1 />
              <span className="sr-only">Close modal</span>
            </button>

            {/* <div className=" flex items-center justify-end pb-5">
              <div className="flex items-center justify-center px-1 relative">
                <MotionSearchBox
                  isSearchActive={isExpanded}
                  setIsSearchActive={setIsExpanded}
                  searchText={searchText}
                  setSearchText={setSearchText}
                  placeholder={"Search..."}
                />
              </div>

              <div className="flex px-1.5">
                <AddButton
                  type={"button"}
                  onClick={() => {
                    openSecondPopup(null, customerId, refetchCustomerData);
                    // closePopup()
                  }}
                >
                  <AddIcon className="w-4 h-4" /> Add
                </AddButton>
              </div>
              <div className="">
                <button
                  onClick={closePopup}
                  type="button"
                  className="text-454545 bg-transparent hover:bg-F1F5F8 rounded-lg text-sm  ms-auto inline-flex justify-center items-center"
                  data-modal-hide=""
                >
                  <CloseModal1 />
                  <span className="sr-only">Close modal</span>
                </button>
              </div>
            </div> */}
          </div>
          {/*----------------------- second part------------------------------- */}

          <div className="tasklistpop min-w-full flex flex-col  bg-white min-h-0 grow border-top border-gray-200 ">
            <div className="flex items-center  px-3 pr-6 gap-2 my-1">
              <MotionSearchBox
                isSearchActive={isExpanded}
                setIsSearchActive={setIsExpanded}
                searchText={searchText}
                setSearchText={setSearchText}
                placeholder={"Search..."}
                expanded={true}
              />
              <button
                type="button"
                onClick={() => openSecondPopup(null, customerId, refetchCustomerData)}
                className="bg-[#0e8bfe1a] border border-[#2999BC] text-[#2999BC] text-sm font-normal flex items-center justify-center gap-x-1 rounded-md h-8 w-20"
              >
                <NewAddIcon className="w-3 h-3" />
                Add
              </button>
            </div>
            {Boolean(filtered?.length) ? (
              <div
                className="flex flex-col py-1 items-center w-full overflow-y-auto thinscrollbar
              px-3"
              >
                {filtered?.map((item, idx) => {
                  return (
                    <>
                      {/* Card content starts */}
                      <div
                        className={`w-full h-full  cursor-pointer relative  pt-2.5  `}
                        // style={{
                        //   borderLeft:
                        //     idx % 2 === 0 ? `4px solid ${item?.priority_colour_code || "transparent"}` : "none",
                        //   borderRight:
                        //     idx % 2 !== 0 ? `4px solid ${item?.priority_colour_code || "transparent"}` : "none",
                        // }}
                        onClick={(e) => {
                          e.stopPropagation();
                          openSecondPopup(item, "New");
                        }}
                      >
                        <UniversalCardComponent
                          item={item}
                          searchValue={searchText}
                          isSecondStyle
                          // onClick={onClick}
                          // isTaskCompleted={isTaskCompleted}
                          TaskCompletionCheckbox={TaskCompletionCheckbox}
                          isStatusShow
                          isTagsShow
                        />
                      </div>
                    </>
                  );
                })}
              </div>
            ) : customer?.length == 0 ? (
              <CircularLoader />
            ) : (
              <div className="px-3 h-full flex justify-center items-center">
                <div className="flex justify-center items-center flex-col space-y-2">
                  <NoTaskIcon />
                  <span className="text-14 text-black text-sm font-400">No Task is Available.</span>
                  {!customer.length && (
                    <span
                      onClick={() => {
                        openSecondPopup(null, customerId, refetchCustomerData);
                        closePopup();
                      }}
                      className="border px-5 py-1.5 items-center text-center text-sm font-400 text-[#383838] rounded-3xl shadow-[0px_1px_0px_0px_rgba(0,0,0,0.10)_inset,0px_0px_4px_0px_rgba(0,0,0,0.15)]"
                    >
                      + Add Task
                    </span>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </CustomDrawer>
      {editData?.is_recurrence === 1 && (
        <EditOptionsModal
          onClose={closePopup}
          onOpen={editData}
          onSave={handleEditFields}
          refetch={refetchCustomerData}
          // checkListOpen={isCheckListOpen}
          // setCheckListOpen={setIsCheckListOpen}
        />
      )}
    </>
  );
};
export default TasListkModal;
